import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";

import beforeEach from "./beforeEach";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    children: [
      // {
      //   path: "/test",
      //   name: "Test",
      //   component: () => import("@/components/approval/ApprovalView.vue")
      // },
      {
        path: "/",
        name: "Main",
        component: () => import("@/views/About.vue")
      },
      {
        path: "/office",
        name: "Office",
        meta: { title: "勤怠登録（所属）" },
        component: () => import("@/views/Office.vue")
      },
      {
        path: "/mainhome",
        name: "MainHome",
        component: () => import("@/views/MainHome.vue")
      },
      // {
      //   path: "/uramainhome",
      //   name: "UraMainHome",
      //   component: () => import("@/views/UraMainHome.vue")
      // },
      {
        path: "/attendance",
        name: "Attendance",
        component: () => import("@/views/AttendanceDetails.vue")
      },
      {
        path: "/shifttable",
        name: "ShiftTable",
        component: () => import("@/views/ShiftTable.vue")
      },
      {
        path: "/approval",
        name: "ApprovalList",
        component: () => import("@/views/ApprovalList.vue")
      },
      {
        path: "/earlywork-appl/admin",
        name: "EarlyWorkApplAdmin",
        component: () => import("@/views/EarlyWorkApplAdmin.vue")
      },
      {
        path: "/approvalpetition",
        name: "ApprovalPetitionList",
        component: () => import("@/views/ApprovalPetitionList.vue")
      },
      {
        path: "/approval/detail",
        name: "ApprovalDetails",
        component: () => import("@/views/ApprovalDetails.vue")
      },
      {
        path: "/approval/petitiondetail",
        name: "ApprovalPetitionDetails",
        component: () => import("@/views/ApprovalPetitionDetails.vue")
      },
      {
        path: "/approval-status",
        name: "ApprovalStatus",
        //component: () => import("@/views/ApprovalStatus.vue")
        component: () => import("@/components/approval/ApprovalView.vue"),
        props: route => ({ value: Number(route.params.value) })
      },
      {
        path: "/check-approval",
        name: "CheckApproval",
        component: () =>
          import("@/components/check-approval/CheckApprovalView.vue"),
        props: route => ({ value: Number(route.params.value) })
      },
      {
        path: "/user-master",
        name: "UserMaster",
        component: () => import("@/views/UserMaster.vue")
      },
      {
        path: "/self",
        name: "SelfUserInfo",
        component: () => import("@/views/GenaralUserMaster.vue")
      },
      {
        path: "/list/:name",
        name: "List",
        component: () => import("@/views/TableView/List.vue")
      },
      // {
      //   path: "/details/:name",
      //   name: "Details",
      //   component: () => import("@/views/TableView/Details.vue"),
      //   props: true
      // },
      {
        path: "/details/shift-pattern",
        name: "ShiftPatternDetails",
        component: () => import("@/views/TableView/ShiftPatternDetails.vue"),
        props: true
      },
      {
        path: "/details/code-group",
        name: "CodeGroupDetails",
        component: () => import("@/views/TableView/CodeGroupDetails.vue"),
        props: true
      },
      {
        path: "/details/code-master",
        name: "CodeMasterDetails",
        component: () => import("@/views/TableView/CodeMasterDetails.vue"),
        props: true
      },
      {
        path: "/details/shozoku-exp",
        name: "ShozokuExpDetails",
        component: () => import("@/views/TableView/ShozokuExpDetails.vue"),
        props: true
      },
      {
        path: "/details/shain-exp",
        name: "ShainExpDetails",
        component: () => import("@/views/TableView/ShainExpDetails.vue"),
        props: true
      },
      {
        path: "/details/daily-event",
        name: "DailyEventDetails",
        component: () => import("@/views/TableView/DailyEventDetails.vue"),
        props: true
      },
      {
        path: "/details/shozoku",
        name: "ShozokuGroup",
        component: () => import("@/views/TableView/ShozokuGroup.vue"),
        props: true
      },
      {
        path: "/details/shain",
        name: "ShainDetails",
        component: () => import("@/views/TableView/ShainDetails.vue"),
        props: true
      },
      {
        path: "/pca-exportmaster",
        name: "PcaExport<aster",
        component: () => import("@/views/PCAExportMaster.vue"),
        props: true
      },
      {
        path: "/details/basemaster",
        name: "BaseMasterDetails",
        component: () => import("@/views/TableView/BaseMasterDetails.vue"),
        props: true
      },
      {
        path: "/details/shozokumaster",
        name: "ShozokuMasterDetails",
        component: () => import("@/views/TableView/ShozokuMasterDetails.vue"),
        props: true
      },
      {
        path: "/AlertDetailList",
        name: "AlertDetailsList",
        component: () => import("@/views/AlertDetailsList.vue"),
        props: true
      },
      {
        path: "/pca-cooperation",
        name: "PcaCooperation",
        component: () => import("@/views/PCAcooperation.vue"),
        props: true
      },
      {
        path: "/affiliation-summary",
        name: "AffiliationSumary",
        component: () => import("@/views/AffiliationSummary.vue"),
        props: true
      },
      {
        path: "/shift-order",
        name: "ShiftOrder",
        component: () => import("@/views/ShiftOrder.vue"),
        props: true
      },
      {
        path: "/shift-pattern-order",
        name: "ShiftPatternOrder",
        meta: { title: "シフトパターン表示順" },
        component: () => import("@/views/ShiftPatternOrder.vue"),
        props: true
      },
      {
        path: "/about",
        name: "About",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/About.vue")
      },
      {
        path: "/debug",
        name: "Debug",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Debug.vue")
      },
      {
        path: "/for-calc",
        name: "ForCalc",
        meta: { title: "時間・給与計算" },
        component: () => import("@/views/ForCalcList.vue")
      },
      {
        path: "/qr-shozoku",
        name: "QrShozoku",
        meta: { title: "所属QRコード" },
        component: () => import("@/views/QrShozoku.vue")
      },
      {
        path: "/qr-shain",
        name: "QrShain",
        meta: { title: "社員QRコード" },
        component: () => import("@/views/QrShain.vue")
      },
      {
        path: "/shift-lock",
        name: "ShiftLock",
        meta: { title: "シフト表ロック" },
        component: () => import("@/views/ShiftLock.vue"),
        props: true
      },
      {
        path: "/authinfo",
        name: "AuthInfoList",
        meta: { title: "ログインアカウント" },
        component: () => import("@/views/AuthInfoList.vue")
      },
      {
        path: "/worktime-summary",
        name: "WorktimeSummary",
        meta: { title: "個人毎施設毎労働時間集計" },
        component: () => import("@/views/WorkTimeSummary.vue")
      }
    ]
  },
  {
    path: "/user",
    name: "UserTop",
    meta: { title: "個人勤怠登録" },
    component: () => import("@/views/UserTop.vue")
  },
  {
    path: "/user-roster",
    name: "UserRoster",
    meta: { title: "個人勤務実績" },
    component: () => import("@/views/UserRoster.vue")
  },
  {
    path: "/user-vacation-request",
    name: "UserVacationRequest",
    meta: { title: "休暇申請" },
    component: () => import("@/views/UserVacationRequest.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
    meta: {
      public: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(beforeEach);

export default router;
